const NEWS_FIELDS = `
  items {
    ItemId
    CreatedDate
    CreatedBy
    IsDeleted
    Tags
    Title
    Content
    attachmentUrls {
      id
      name
      size
      url
      mimeType
    }
    authorSnapshot {
      firstName
      lastName
      email
      profileImageUrl
    }
    coverImageUrl
    categoryIds
    isDraft
    isPinned
  }
`;

export const GET_NEWS = `
  query GetNews($filter: String!, $sort: String, $pageSize: Int!, $pageNo: Int!) {
    getnewss(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      ${NEWS_FIELDS}
    }
  }
`;

export const GET_NEWS_ITEM = `
  query GetNewsItem($filter: String!) {
    getnewss(
      input: {
        filter: $filter
        sort: "{}"
        pageNo: 1
        pageSize: 1
      }
    ) {
      ${NEWS_FIELDS}
    }
  }
`;

export const GET_ALL_CATEGORIES = `
  query GetAllCategories($filter: String!) {
    getcategorys(
      input: {
        filter: $filter
        sort: "{}"
        pageNo: 1
        pageSize: 1000
      }
    ) {
      items {
        ItemId
        categoryName
        Tags
      }
    }
  }
`;

export const DELETE_NEWS = `
  mutation DeleteNews($filter: String!) {
    deletenews(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every news item created by a user (used by the user-deletion purge).
export const DELETE_MANY_NEWS_BY_CREATOR = `
  mutation DeleteManyNewsByCreator($createdBy: String!) {
    deleteManynews(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

export const CREATE_NEWS = `
  mutation CreateNews($input: newsInsertInput!) {
    insertnews(input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_NEWS = `
  mutation UpdateNews($filter: String!, $input: newsUpdateInput!) {
    updatenews(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
